import React from 'react';

/**
 * Shared width/padding for RISP & SOI entry pages so Outbreak, Vaccination,
 * Surveillance, and Market Price align visually.
 */
const RispPageShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="w-full max-w-7xl mx-auto px-4 sm:px-6">{children}</div>
);

export default RispPageShell;
